/**
 *  Rôle : SideBar
 * Copyright: © 2021 Remote Monkey S.A.S.U http://remote-monkey.fr
 */
import React from 'react';
// import Advertisement from '../advertisement/Advertisement';
// import Newsletter from '../newsletter/Newsletter';
// import Images from '../../content/ListeLastRappels';
import Categories from './componentSideBar/Categories';
import Coran from './componentSideBar/Coran';
import MenuSidebar from './componentSideBar/MenuSidebar';
import SocialSideBar from './componentSideBar/SocialSideBar';

const SideBar = (props) => {
	const { type, categories, liste, selectCategorie, modCategoriesDisplay } = props;

	return (
		<>
			{modCategoriesDisplay === false ? (
				<></>
			) : (
				<Categories
					type={type}
					categories={categories}
					liste={liste}
					selectCategorie={selectCategorie}
				/>
			)}
			{modCategoriesDisplay === false ? (
				<MenuSidebar marginTop="mt-0" />
			) : (
				<MenuSidebar marginTop="mt-5" />
			)}
			<Coran theme="dark" />

			<SocialSideBar />
		</>
	);
};

export default SideBar;
